import { get } from 'lodash'
import { ISellerHeader, TMenuItem, TPermission } from 'containers/App/appLayoutTypes'

interface IUserMenuItems {
  menu: TMenuItem[]
  currentSeller?: ISellerHeader
  sellerPermissions: TPermission | undefined
}

const useMenuItems = ({ currentSeller, menu, sellerPermissions }: IUserMenuItems) => {
  return menu
    .filter(menuItem => {
      if (menuItem.service_id === null) {
        return true
      }

      if (currentSeller?.accountServices) {
        const tenantPermissions = get(sellerPermissions, currentSeller?.tenantId, undefined)
        return tenantPermissions ? tenantPermissions[menuItem.service_id] : false
      }

      return true
    })
    .map(item => {
      if (item.paramsOnRedirect?.length && currentSeller) {
        const params = Object.assign(
          {},
          // eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
          ...Object.entries({ ...item.paramsOnRedirect }).map(([_, key]) => ({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            [key as string]: currentSeller[key],
          }))
        )

        const urlParams = new URLSearchParams(params).toString()

        return {
          ...item,
          external: true,
          url_production: `${item.url_production}?${urlParams}`,
          url_staging: `${item.url_staging}?${urlParams}`,
          url: `${item.url}?${urlParams}`,
        }
      }
      return {
        ...item,
        external: true,
      }
    })
}

export { useMenuItems }
